<div class="neti-powered-by">
    Powered by "<a
        :href="pluginLink"
        rel="noopener"
        target="_blank"
    >{{ pluginName }}</a>" -

    <a
        href="https://netinventors.de/"
        target="_blank"
    >Net Inventors GmbH</a>
</div>